/** The message under a field that is not a <Field> (e.g. the sign-in form). Same id convention as <Field>. */
export function FieldError({ id, error }: { id: string; error: string | null }) {
  return error ? <p id={`${id}-error`} role="alert" className="text-xs text-bad">{error}</p> : null;
}
